import angular from 'angular';
import { StateProvinceListComponent } from './state-province-list.component';

export const StateProvinceModule = angular
    .module("apex.mainApp.stateProvince", [])
    .component("apexStateProvinceList", StateProvinceListComponent)
    .name;

